export enum SystemLogEventLevelKinds {
  Info = 0,
  Warn = 4,
  Error = 8,
  Fatal = 12,
}
